import type { ICustomer } from '@/modules/perseo-billing/interfaces/src/bff-web/billing';
import {
  Divider,
  Icon,
  Typography
} from '@/modules/perseo-billing/ui/react/src/components/beta';

import PaymentCompleteStepper from './stepper.component';

type RequestReceivedProps = {
  order: string;
  customer: ICustomer;
};

export const RequestReceived = ({ order, customer }: RequestReceivedProps) => {
  const firstName = customer?.firstName || '';
  const capitalizedFirstName =
    firstName?.charAt(0)?.toUpperCase() + firstName?.slice(1);
  const thankYouMessage = `¡${capitalizedFirstName}, gracias por tu compra!`;

  return (
    <div className="co-w-full co-relative co-flex co-flex-col co-rounded-8px co-gap-16px co-py-24px co-px-16px co-border-1 co-border-[#4DAC44] lg:co-py-24px lg:co-px-32px co-bg-white">
      <Icon
        className="co-flex lg:co-hidden co-justify-center co-items-center co-absolute co-w-56px co-h-56px co--top-24px co-left-0 co-right-0 co-mx-auto co-p-[12px] co-rounded-[100px] co-bg-[#4DAC44]"
        icon="ConfirmationCheckIcon"
      />
      <div className="co-flex co-flex-col co-justify-between lg:co-flex-row co-pt-16px co-gap-16px lg:co-pt-0 lg:co-gap-8px">
        <div className="co-flex co-items-center co-p-2 co-gap-4" tabIndex={0}>
          <Icon
            icon="ConfirmationCheckIcon"
            className="co-hidden lg:co-flex co-justify-center co-items-center co-w-48px co-h-48px co-p-8px co-rounded-[100px] co-bg-[#4DAC44]"
          />
          <Typography
            weight="bold"
            size="h2"
            align="center"
            className="co-justify-center lg:co-mr-auto"
          >
            {thankYouMessage}
          </Typography>
        </div>
        <div
          tabIndex={0}
          className="co-flex co-p-8px co-rounded-4px co-gap-8px co-bg-[#E4F7E0] co-text-[16px] co-items-center"
        >
          <Icon
            icon="ShoppingBagIcon"
            width={24}
            height={24}
            color="#0D7A26"
            className="co-min-w-24px co-min-h-24px co-fill-current co-text-[#0D7A26]"
          />
          <Typography size="h4" noWrap>
            {'Tu compra '}
            <span className="co-font-bold co-text-[16px]">Nº {order}</span>
            {' se está procesando.'}
          </Typography>
        </div>
      </div>

      <Divider />

      <Typography size="h4" noWrap tabIndex={0}>
        {'Te enviaremos un correo a '}
        <span className="co-font-bold co-text-[16px]">
          {customer?.email}
        </span>{' '}
        {
          'con la solicitud de compra. Si no recibes el correo en dos minutos, revisa tu carpeta de correo no deseado. También puedes hacer seguimiento de tu producto en Mis compras.'
        }
      </Typography>

      <div
        tabIndex={0}
        className="co-hidden lg:co-flex co-w-full co-justify-center co-py-24px co-rounded-4px co-bg-pds-neutral-100"
      >
        <PaymentCompleteStepper orientation="horizontal" />
      </div>
      <div
        tabIndex={0}
        className="co-flex lg:co-hidden co-w-full co-p-16px co-rounded-4px co-bg-pds-neutral-100"
      >
        <PaymentCompleteStepper orientation="vertical" />
      </div>
    </div>
  );
};
